var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{staticClass:"video-js",attrs:{"id":"my-video","autoplay":"autoplay","controls":"","playsinline":"","webkit-playsinline":"","controlslist":"nodownload"}})
}
var staticRenderFns = []

export { render, staticRenderFns }